import { getSiteBranding as fetchSiteBrandingApi } from './api';

const DEFAULT_SITE_NAME = '源头批发商城';

let cached = {
  site_name: DEFAULT_SITE_NAME,
  site_favicon: '',
  loaded: false,
};

export function getCachedSiteBranding() {
  return cached;
}

export function applyFavicon(url) {
  const href = String(url || '').trim();
  if (!href) return;
  let link = document.querySelector("link[rel*='icon']");
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'icon');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

export function applySiteTitle(title) {
  const name = String(title || '').trim() || DEFAULT_SITE_NAME;
  document.title = name;
}

export function applySiteBranding(branding) {
  if (!branding || typeof branding !== 'object') return;
  if (branding.site_name) {
    cached.site_name = String(branding.site_name).trim() || DEFAULT_SITE_NAME;
  }
  if (branding.site_favicon != null) {
    cached.site_favicon = String(branding.site_favicon || '').trim();
  }
  applySiteTitle(cached.site_name);
  if (cached.site_favicon) {
    applyFavicon(cached.site_favicon);
  }
}

/** 拉取并应用网站名称 / 图标 */
export async function loadAndApplySiteBranding() {
  try {
    const res = await fetchSiteBrandingApi();
    const data = res?.data || {};
    applySiteBranding(data);
    cached.loaded = true;
    return cached;
  } catch (e) {
    console.warn('[siteBranding] 加载失败，使用默认名称', e);
    applySiteTitle(DEFAULT_SITE_NAME);
    return cached;
  }
}

/** 路由标题：首页用站点名，其它页用 meta.title */
export function resolveDocumentTitle(route) {
  const metaTitle = route?.meta?.title;
  if (
    !metaTitle ||
    route?.name === 'Home' ||
    metaTitle === '源头批发商城' ||
    metaTitle === DEFAULT_SITE_NAME
  ) {
    return cached.site_name || DEFAULT_SITE_NAME;
  }
  return String(metaTitle);
}
